import React from 'react';
import { Typography, Popover, Button } from '@material-ui/core';
import { formStyles } from './styles';

interface PopoverWarnProps {
  index: number;
  message: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  anchorEl: HTMLButtonElement | null;
  deleteItem: (index: number) => void;
}
const AccordionDeletWarn: React.FC<PopoverWarnProps> = ({
  open,
  setOpen,
  index,
  anchorEl,
  deleteItem,
  message,
}) => {
  const classes = formStyles();

  return (
    <Popover
      PaperProps={{ className: classes.deleteWarn }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Typography className={classes.message}>{message}</Typography>
      <Button
        size="small"
        style={{ backgroundColor: '#00a7c533' }}
        variant="outlined"
        onClick={() => {
          deleteItem(index);
          setOpen(false);
        }}
      >
        Remover
      </Button>
      <Button
        size="small"
        style={{ backgroundColor: '#c5002433' }}
        variant="outlined"
        onClick={() => setOpen(false)}
      >
        Cancelar
      </Button>
    </Popover>
  );
};

export default AccordionDeletWarn;
